"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = exports.BADGE_SIZES = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../mantine-theme/src");
var Badge_styles_1 = __importStar(require("./Badge.styles"));
exports.BADGE_SIZES = Badge_styles_1.heights;
function Badge(_a) {
    var _b = _a.component, Component = _b === void 0 ? 'div' : _b, className = _a.className, color = _a.color, _c = _a.variant, variant = _c === void 0 ? 'light' : _c, fullWidth = _a.fullWidth, children = _a.children, themeOverride = _a.themeOverride, _d = _a.size, size = _d === void 0 ? 'md' : _d, leftSection = _a.leftSection, rightSection = _a.rightSection, _e = _a.radius, radius = _e === void 0 ? 'xl' : _e, others = __rest(_a, ["component", "className", "color", "variant", "fullWidth", "children", "themeOverride", "size", "leftSection", "rightSection", "radius"]);
    var classes = Badge_styles_1.default({
        size: size,
        fullWidth: fullWidth,
        color: color,
        radius: radius,
        theme: theme_1.useMantineTheme(themeOverride),
    });
    return (react_1.default.createElement(Component, __assign({}, others, { "data-mantine-composable": true, className: clsx_1.default(classes.badge, classes[variant], className) }),
        leftSection && (react_1.default.createElement("span", { "data-mantine-badge-left": true, className: classes.leftSection }, leftSection)),
        react_1.default.createElement("span", { className: classes.inner }, children),
        rightSection && (react_1.default.createElement("span", { "data-mantine-badge-right": true, className: classes.rightSection }, rightSection))));
}
exports.Badge = Badge;
Badge.displayName = '@mantine/core/Badge';
